<template>
  <!-- <div @click="setFocus(-1)"> -->
  <div>
    <s-header>
      <div class="mt-3 -mb-3">Receiving</div>
    </s-header>

    <section
      v-if="!isInvoice"
      class="mt-4 sm:mt-8 px-6 py-2 text-lg sm:text-2xl font-semibold text-gray-800 text-left leading-tight border-l-4 border-gray-800"
    >
      {{
        "Today's invoices have already been entered, or none are expected. " +
        (isFutureInvoice ? 'Upcoming invoices ' : '') +
        (isFutureInvoice && isPastIncompleteInvoice ? 'and p' : '') +
        (!isFutureInvoice && isPastIncompleteInvoice ? 'P' : '') +
        (isPastIncompleteInvoice ? 'ast incomplete invoices ' : '') +
        'are listed below.'
      }}
    </section>

    <section class="flex flex-row justify-start">
      <s-button
        left-icon="camera"
        class="mt-6 mb-6 mr-6 shadow-lg z-0"
        @click="$router.push('/invoicing/receive')"
      >
        Scan Invoice
      </s-button>
    </section>

    <section class="mt-10">
      <invoice
        v-for="(invoice, index) in invoicesPastIncomplete"
        :pastdue="true"
        :ref="`invoice-${invoice}`"
        :key="invoice"
        :invoice-id="invoice"
        :index="index"
        :active-item="activeChild"
        @focused="setFocus($event)"
        class="mt-4"
      />
      <invoice
        v-for="(invoice, index) in invoicesToday"
        :key="invoice"
        :ref="`invoice-${invoice}`"
        :invoice-id="invoice"
        :index="index"
        :active-item="activeChild"
        @focused="setFocus($event)"
        class="mt-4"
      />
      <invoice
        v-for="(invoice, index) in invoicesFuture"
        :locked="true"
        :key="invoice"
        :ref="`invoice-${invoice}`"
        :invoice-id="invoice"
        :index="index"
        :active-item="activeChild"
        @focused="setFocus($event)"
        class="mt-4"
      />
    </section>

    <!-- Legacy create flow — preserved for edge cases -->
    <section v-if="false" class="flex flex-row justify-start">
      <s-button
        left-icon="file-plus"
        class="mt-6 mr-6 shadow-lg z-0"
        @click="
          $modal.show('modal--selection-vendor', {
            list: vendorsActive,
            display: vendorName
          })
        "
      >
        Create New
      </s-button>
    </section>

    <modal-selection @confirm="addProduct" />
    <modal-selection-vendor @confirm="createInvoiceByVendorId" />
  </div>
</template>

<script>
import Invoice from '@/components/Invoice'
import SHeader from '@/components/SHeader'
import SButton from '@/components/Button'
import ModalSelection from '@/components/ModalSelection'
import ModalSelectionVendor from '@/components/ModalSelectionVendor'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'InvoiceList',
  data: function () {
    return {
      activeChild: -1
    }
  },
  components: {
    Invoice,
    SHeader,
    ModalSelection,
    ModalSelectionVendor,
    SButton
  },
  computed: {
    ...mapGetters('user', ['isManager', 'isStaff']),
    ...mapGetters('storeModule/invoices', [
      'invoicesToday',
      'invoicesFuture',
      'invoicesPastIncomplete',
      'invoices'
    ]),
    ...mapGetters('storeModule/vendors', ['vendorsActive', 'vendorName']),
    isInvoice() {
      return this.invoicesToday && this.invoicesToday.length > 0
    },
    isFutureInvoice() {
      return this.invoicesFuture && this.invoicesFuture.length > 0
    },
    isPastIncompleteInvoice() {
      return (
        this.invoicesPastIncomplete && this.invoicesPastIncomplete.length > 0
      )
    }
  },
  methods: {
    ...mapActions('storeModule/invoices', [
      'createInvoiceByVendorId',
      'addProductToInvoice'
    ]),
    addProduct: async function (event) {
      return this.addProductToInvoice(event)
        .then(() => {
          this.$nextTick(() => {
            // exit if items
            // prettier-ignore
            if (!this.$refs[`invoice-${event.invoiceId}`][0]
                     .$refs[`invoice-items-${event.invoiceId}`]
                     .$refs[`invoice-item-${event.invoiceId}-${event.productId}`]) 
              return

            // scroll to new element
            // prettier-ignore
            this.$refs[`invoice-${event.invoiceId}`][0]
                .$refs[`invoice-items-${event.invoiceId}`]
                .$refs[`invoice-item-${event.invoiceId}-${event.productId}`][0]
                .$el.scrollIntoView({ behavior: 'smooth', block: 'center' })

            // set focus on new Product totalCost input,
            // preventScroll: true - allows the smooth scroll from above to finish
            // prettier-ignore
            this.$refs[`invoice-${event.invoiceId}`][0]
                .$refs[`invoice-items-${event.invoiceId}`]
                .$refs[`invoice-item-${event.invoiceId}-${event.productId}`][0]
                .$refs[`inputTotalCost_${event.invoiceId}_${event.productId}`]
                .$el.focus({ preventScroll: true })
          })
        })
        .catch((error) => {
          console.log(error)
        })
    },
    setFocus: function (i) {
      this.activeChild = i
    }
  }
}
</script>
